import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["onClick", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { IconButton, IconClose } from '@lmig/lmds-react-icons';
import React from 'react';
import classnames from 'classnames';
/**
 *  Component to display the close X button in the upper right hand corner of the Modal.
 */
export var ModalClose = function ModalClose(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classNames = classnames('lmig-Modal-close', className);
  return /*#__PURE__*/React.createElement(IconButton, _extends({
    initialSize: "16",
    onClick: onClick,
    className: classNames
  }, rest), /*#__PURE__*/React.createElement(IconClose, {
    size: "16"
  }));
};
ModalClose.propTypes = {
  /** event to fire when the user clicks on the close button */onClick: _pt.func.isRequired,
  /** Add custom classes to this element: `<button class="lmig-Modal-close">`. */className: _pt.string
};